import { loadQuery, PreloadedQuery } from 'react-relay';

import { getRelayEnvironment } from '@townsquare/relay-utils/townsquare-environment';
import { matchRoute } from '@townsquare/router/primitives/match-route';
import { createSearchParamsFromCurrentUrl } from '@townsquare/search-params';

import { routes } from '../router/routes';

import BootstrapTeamsQuery, {
	BootstrapTeamsQuery$variables,
	type BootstrapTeamsQuery as BootstrapTeamsQueryType,
} from './__generated__/BootstrapTeamsQuery.graphql';

export const preloadQueryRef = (): PreloadedQuery<
	BootstrapTeamsQueryType,
	Record<string, never>
> => {
	const urlSearch = Object.fromEntries(createSearchParamsFromCurrentUrl());
	const matchedRoute = matchRoute(routes, window.location.pathname, urlSearch);
	const context: NonNullable<BootstrapTeamsQuery$variables['context']> = {
		orgId: matchedRoute?.match.params.orgIdentifier,
		cloudId: matchedRoute?.match.params.siteIdentifier || urlSearch.cloudId,
	};

	const contextExists = context.orgId || context.cloudId;

	const RelayEnvironment = getRelayEnvironment();

	return loadQuery<BootstrapTeamsQueryType>(
		RelayEnvironment,
		BootstrapTeamsQuery,
		contextExists ? { context } : {},
	);
};
